import { useContext } from 'react';
import { GroupContext, GroupContextValue } from '@/contexts/group/GroupContext';

export function useGroups(): GroupContextValue {
  const ctx = useContext(GroupContext);
  if (!ctx) throw new Error("useGroups must be used within GroupProvider");
  return ctx;
}